import router from "./router";
import store from "./store";
import { MessageBox, Message } from "element-ui";
import NProgress from "nprogress"; // progress bar
import "nprogress/nprogress.css"; // progress bar style
import { getToken, setToken } from "@/utils/auth"; // get token from cookie
import { confirmCarryVerification,requestGetBrowse } from "@/utils/common"; // get token from cookie
import getPageTitle from "@/utils/get-page-title";
import { getBrowsingTracker } from "@/utils/browsingDurationTracker";
NProgress.configure({ showSpinner: false }); // NProgress Configuration

const whiteList = ["/oauth", "/oauth2", "/verifyemail", "/redirect", '/wiki', '/home', '/learn', '/awards', "/success",'/forum','/blueprint','/my']; // no redirect whitelist
// const mobilePage = [ '/wiki', '/home', '/learn', '/awards','/my','/forum']; // 
const mobilePage = [ '/wiki']; // 移动端代码

// , '/document', '/home', '/videoSchool'

router.beforeEach(async (to, from, next) => {
   // 移动端代码
  if (mobilePage.some((w) => to.path.includes(w))) {
      document.documentElement.classList.add('mobile_page')
    } else {
      document.documentElement.classList.remove('mobile_page')
    }

  NProgress.start();
  
  // 初始化浏览时长追踪器
  const browsingTracker = getBrowsingTracker();
  
  if (location.href.indexOf("&logout=1") > -1) {
    await store.dispatch("user/logout"); // 清空本地cookie数据
  }
 
  if(to.meta.metaInfo){
    store.commit("metaModule/SET_META_INFO", to.meta.metaInfo)
  }else{
     document.title = getPageTitle(to.meta.title);
  }
  // debugger
  // if (to.query.test) {
  //   window.location.reload("www.baidu.com");
  //   // next("/redirect?redirect=www.baidu.com");
  //   return;
  // }
  const isNeedFreashUserInfo = confirmCarryVerification()
  if (isNeedFreashUserInfo) {
    try {
      if (isNeedFreashUserInfo.ticket && getToken() === isNeedFreashUserInfo.ticket) {
        next();
      } else if (isNeedFreashUserInfo.ticket) {
        setToken(isNeedFreashUserInfo.ticket)
        next();
      } else {

        const res = await store.dispatch("user/loginByToken", { token: isNeedFreashUserInfo.token });

        if ([1, 2].includes(res.data.userStat)) {
          // 删除、冻结
          window.location.replace("/#/approve");
          next("/approve");
        } else if (res.data.userStat === 0 || res.data.ea_status === 0) {
          // 正常;
          window.location.replace("/#/redirect?redirect=" + encodeURIComponent(isNeedFreashUserInfo.redirect_url));
          next("/redirect?redirect=" + encodeURIComponent(isNeedFreashUserInfo.redirect_url));
          return;
        } else if ([4, 7, 8].includes(res.data.userStat)) {
          // 4：待签署合同 7:待填写邀请码 8:重复签署
          window.location.replace("/#/apply");
          next("/apply");
        } else {
          Message.error(res?.msg ?? '登录失败')
          window.location.replace("/#/home");
          next("/home");
        }
      }
      NProgress.done();
      return;
    }
    catch (error) {
      MessageBox.alert(error.message || error.msg || "Has Error", {
        type: "error",
      }).then(async () => {
        await store.dispatch("user/logout");
        window.location.replace("/#/home");
        next("/home");
        NProgress.done();
      });
      return;
    }
  }

      // 初始化并切换浏览时长追踪器
    browsingTracker.init();
    browsingTracker.switchPage(to.path,window.location.origin + '/#' + to.fullPath);
    
    requestGetBrowse(to) // 记录浏览记录

  const hasToken = getToken();
  if (hasToken) {
    store.dispatch("user/setIsLogin");
  
    if (whiteList.some((w) => to.path.includes(w))) {
      next();
      NProgress.done();
    } else {
      const hasAuth = store.getters.auth && store.getters.auth.length > 0;
      if (hasAuth) {
        next();
      } else {
        try {
          const { auth, userStat } = await store.dispatch("user/getInfo");
          if ([1, 2].includes(userStat)) {
            // 删除、冻结
            next("/approve");
            // 待签署、重复签署
          } else if ([4, 8].includes(userStat)) {
            next({
              ...to,
              path: "/apply",
            });
          }
          else {
            const { role } = store.getters;
            const accessRoutes = await store.dispatch(
              "permission/generateRoutes",
              [auth, role]
            );
            router.addRoutes(accessRoutes);
            next({ ...to, replace: true });
          }
        } catch (error) {
          MessageBox.alert(error.message || error.msg || "Has Error", {
            type: "error",
          }).then(async () => {
            await store.dispatch("user/logout");
            next(`/home?login=0&redirect=${to.path}`);
            NProgress.done();
          });
        }
      }
    }
  } else {
    if (whiteList.some((w) => to.path.includes(w)) && to.path !== "/forum/newpost") {
      next();
    } else {
      await store.dispatch("user/logout"); // 清空本地cookie数据
      next(
        `/oauth?app_id=5012568a421eeb0b&redirect_url=${location.origin}/#${to.path}`
      );
      NProgress.done();
    }
  }
});

router.afterEach(() => {
  NProgress.done();
});
